import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-exclamation",
  "use": "icon-cl-exclamation-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-exclamation\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 11a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol